import { render, staticRenderFns } from "./DelayAnim.vue?vue&type=template&id=1cf1d423&scoped=true"
import script from "./DelayAnim.vue?vue&type=script&lang=ts"
export * from "./DelayAnim.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf1d423",
  null
  
)

export default component.exports